import { useQuery } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'

const normalizeQueryResponse = (response) => {
  if (response?.status === 204) return []

  if (response && typeof response === 'object' && 'status' in response) {
    if (response.status >= 200 && response.status < 300) {
      if (typeof response.data !== 'object') {
        throw new Error(
          `The API did not return JSON. Type received: ${typeof response.data}`
        )
      }
      return response.data ?? []
    }

    throw new Error(`Request failed with status ${response.status}`)
  }

  if (typeof response !== 'undefined' && response !== null && typeof response !== 'object') {
    throw new Error(
      `The API did not return JSON. Type received: ${typeof response}`
    )
  }

  return response ?? []
}

/**
 * Hook genérico para peticiones GET con React Query
 * @param {string[]} queryKey - clave única para cache de react-query
 * @param {string} service - nombre del servicio para getApi
 * @param {string|Function} endpoint - endpoint a consultar o fetcher personalizado
 * @param {object} options - opciones extra de react-query (enabled, staleTime, etc.)
 * @param {object} configOverride - configuración extra opcional para getApi
 */
export const useApiQuery = (
  queryKey,
  service,
  endpoint,
  options = {},
  configOverride
) => {
  const { meta: optionsMeta, ...restOptions } = options

  return useQuery({
    queryKey,
    queryFn: async () => {
      const defaultConfig =
        service === 'schools'
          ? { authenticated: true, version: 3 }
          : { authenticated: true }

      const client = await getApi(service, configOverride || defaultConfig)
      const response = typeof endpoint === 'function'
        ? await endpoint(client)
        : await client.get(endpoint)

      return normalizeQueryResponse(response)
    },
    meta: {
      service,
      endpoint: typeof endpoint === 'string' ? endpoint : '[custom-endpoint]',
      ...optionsMeta
    },
    // Permite sobrescribir cualquier valor si el `hook lo necesita
    ...restOptions
  })
}
